export function setPropertiesWithEmptyStringToNull(object){
    for (let propName in object) {
        if (object[propName] === "") {
            object[propName] = null;
        }
    }
    return object;
}